"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchIcon = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _navigation = require("../../context/navigation");
var _useSearchInputPlaceholder = require("../../hooks/useSearchInputPlaceholder");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchIcon = () => {
  const {
    hideSearchResultsTab
  } = (0, _navigation.useActiveMenu)();
  const {
    isVisible,
    hide,
    show,
    manualShow,
    manualHide
  } = (0, _navigation.useSearchInput)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const searchPlaceholder = (0, _useSearchInputPlaceholder.useSearchInputPlaceholder)();
  const handleClick = (0, _react.useCallback)(() => {
    if (isVisible) {
      manualHide();
      hide();
      hideSearchResultsTab();
    } else {
      show();
      manualShow();
    }
  }, [hide, hideSearchResultsTab, isVisible, manualHide, manualShow, show]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchIconRoot, {
    disableRipple: true,
    "aria-label": searchPlaceholder,
    "data-testid": getTestId(_constants.SEARCH_ICON),
    onClick: handleClick,
    children: isVisible ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Search, {
      fontSize: "inherit"
    })
  });
};
exports.SearchIcon = SearchIcon;
